import React, { FC } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { ClubFittingType } from 'common/infrastructure/modules/appointment/interfaces/AvailabilityTypes';
import { formatDuration } from 'date-fns';

import HorizontalCard, { HorizontalCardType } from 'infrastructure/components/HorizontalCard';
import { formatPhoneNumber } from 'infrastructure/targets/web/modules/common/helpers';
import { getFittingTypeImage } from 'infrastructure/targets/web/modules/common/imageUrlHelpers';
import { StyledTitleContainer } from 'infrastructure/targets/web/modules/bookingWizard/Steps/SelectFittingTypesStep/style';

interface IClubFittingByTime {
  heading: string;
  ctaContent: string;
  clubFittingTypes?: ClubFittingType[];
  phoneNumber?: string;
  nextStep: (value: ClubFittingType) => void;
}

const ClubFittingbyTime: FC<IClubFittingByTime> = ({
  heading,
  ctaContent,
  clubFittingTypes,
  phoneNumber,
  nextStep,
}) => (
  <>
    <StyledTitleContainer>
      <Typography variant="h3">{heading}</Typography>
    </StyledTitleContainer>
    {clubFittingTypes?.length === 0 && (
      <Box padding={6}>
        <Typography variant="h5" textAlign="center">
          {`Club fitting is not currently available. Please select another location or call
    ${formatPhoneNumber(phoneNumber)} to get more information.`}
        </Typography>
      </Box>
    )}
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {clubFittingTypes?.map((el) => (
        <HorizontalCard
          key={el.id}
          variant={HorizontalCardType.Small}
          title={el.name}
          noBottomMargin
          boxShadow
          handleCTA={() => nextStep(el)}
          ctaContent={ctaContent}
          content={
            <span>
              <Chip
                variant="filled"
                size="medium"
                color="default"
                label={formatDuration(
                  { hours: Number(el.duration) / 60 },
                  { format: ['hours'], zero: true },
                ).replace(/hour/g, 'Hour')}
              />
            </span>
          }
          imageUrl={getFittingTypeImage(el.name)}
          imageSx={{
            backgroundColor: '#0000001A',
          }}
        />
      ))}
    </Box>
  </>
);

export default ClubFittingbyTime;
